// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".qr-code {\n  margin: auto;\n  max-width: 100%;\n}\n", "",{"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/vue/components/QRCodes/QRCode.vue","QRCode.vue"],"names":[],"mappings":"AACA;EACI,YAAA;EACA,eAAA;ACAJ","file":"QRCode.vue","sourcesContent":["\n.qr-code {\n    margin: auto;\n    max-width: 100%;\n}\n",".qr-code {\n  margin: auto;\n  max-width: 100%;\n}\n"]}]);
// Exports
module.exports = exports;
